// extracted by mini-css-extract-plugin
export default {"AbilitiesCell__text":"AbilitiesCell_AbilitiesCell__text__Z62Gv"};